import { ComponentConfig } from "@measured/puck";
import { Box, useTheme } from "@mui/material";

import ColorPickerField from "src/components/Puck/config/fields/ColorPickerField";
import { IndicatorItem, IndicatorsSection as IndicatorsSectionComponent } from "./IndicatorsSection";

export type IndicatorsSectionProps = {
    indicators: IndicatorItem[];
};
export const IndicatorsSection: ComponentConfig<IndicatorsSectionProps> = {
    label: "Indicators Section",
    fields: {
        indicators: {
            type: "array",
            label: "Indicators",
            arrayFields: {
                pilarTitle: {
                    type: "text",
                    label: "Pilar title",
                },
                title: {
                    type: "text",
                    label: "Title",
                },
                tooltip: {
                    type: "text",
                    label: "Tooltip",
                },
                value: {
                    type: "text",
                    label: "Value",
                },
                valueColor: {
                    type: "custom",
                    label: "Value color",
                    render: (props) => <ColorPickerField {...props} />,
                },
                unit: {
                    type: "text",
                    label: "Unit",
                },
                objectives: {
                    type: "array",
                    label: "Objectives",
                    arrayFields: {
                        year: {
                            type: "text",
                            label: "Year or label",
                        },
                        value: {
                            type: "text",
                            label: "Value",
                        },
                        unit: {
                            type: "text",
                            label: "Unit",
                        },
                    },
                },
            },
        },
    },
    defaultProps: {
        indicators: [
            {
                pilarTitle: "Insert pilar title",
                title: "Insert title",
                tooltip: "Insert tooltip content",
                value: "0",
                valueColor: "#2e7d32",
                unit: "unit",
                objectives: [
                    { year: "Objective 2025:", value: "0", unit: "unit" },
                    { year: "Objective 2030:", value: "0", unit: "unit" },
                ],
            },
            {
                pilarTitle: "Insert pilar title",
                title: "Insert title",
                tooltip: "Insert tooltip content",
                value: "0",
                valueColor: "#2e7d32",
                unit: "unit",
                objectives: [
                    { year: "Objective 2025:", value: "0", unit: "unit" },
                    { year: "Objective 2030:", value: "0", unit: "unit" },
                ],
            },
            {
                pilarTitle: "Insert pilar title",
                title: "Insert title",
                tooltip: "Insert tooltip content",
                value: "0",
                valueColor: "#2e7d32",
                unit: "unit",
                objectives: [
                    { year: "Objective 2025:", value: "0", unit: "unit" },
                    { year: "Objective 2030:", value: "0", unit: "unit" },
                ],
            },
        ],
    },
    render: (props) => {
        const IndicatorsSectionWrapper = () => {
            const theme = useTheme();
            return (
                <Box sx={{ padding: theme.spacing(2, 0) }}>
                    <IndicatorsSectionComponent {...props} />
                </Box>
            );
        };

        return <IndicatorsSectionWrapper />;
    },
};
